
import { makeStyles } from '@mui/styles';
import { rgbaToHex } from '../../commons/utils/css';

export function buttonCSSFallback (p) {
  const {
    computedStyle,
    widgetTheme,
    setWidgetTheme,
  } = p;
  const hex = rgbaToHex(computedStyle.backgroundColor);
  if (hex === '#00000000') {
    setWidgetTheme({
      ...widgetTheme,
      shouldUseButtonDefault: true,
    });
  }
}

const styles = (theme) => ({

  container: () => {
    return  {
        display: 'flex',
        height: '100vh',
        width: '100%',
      
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'scroll',
    };
  },

  headerSpace: {
    width: '100%',
    // marginBottom: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: ({ commonUIStyles }) => {
    function getHeight () {
      return 'calc(100%)';
    }
 

    return {
      display: 'flex',
      flexDirection: 'column !important',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'hidden',
      width: '100%',
      height: getHeight(),

    	/* rest of css*/
      // overflowY: 'scroll',
      padding: '0px',

      /* for firefox*/
      scrollbarColor: 'transparent transparent',
      scrollbarWidth: '12px',

      '&::-webkit-scrollbar': {
          width: '12px',
          background: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderradius: '5px',
      },

      '&:hover': {
          'scrollbarColor': '#D9D9D9 transparent',
      },

    };
  },

  actionPanel: ({ widgetTheme }) => {
    // const wt = widgetTheme;
    return  {
      display: 'flex',
      width: '100%',
      height: '50px',
      marginBottom: '40px',
      // borderTop: `${wt.borderWidth} ${wt.borderStyle} ${wt.grey3}`,
      // background: wt.grey4,
      // padding: wt.paddingLarge,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column !important',

    };
  },

  list: ({ elementsHeight }) => {
    function getHeight () {
      if (!elementsHeight) {
        return 'calc(100% - 360px)';
      }
      return `calc(100% - ${60 + elementsHeight}px)`;
    }

    return  {
      display: 'flex',
      overflowX: 'hidden',
      width: '100%',
      height: getHeight(),
      justifyContent: 'center',

    	/* rest of css*/
      overflowY: 'scroll',
      paddingLeft: '17px',
      paddingRight: '5px',

      /* for firefox*/
      scrollbarColor: 'transparent transparent',
      scrollbarWidth: '12px',

      '&::-webkit-scrollbar': {
          width: '12px',
          background: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderradius: '5px',
      },

      '&:hover': {
          'scrollbarColor': '#D9D9D9 transparent',
      },
    };
  },

  listContent: ({schedules}) => {

    return  {
      display: 'flex',
      flexWrap: 'wrap',
      width: '463px',
      justifyContent: schedules?.length > 4 ? 'flex-start' : 'center',
      alignContent: 'flex-start',
      columnGap: '5px',
      
      [theme.breakpoints.down('xs')]: {
        width: `calc(100% - 64px)`,
        minWidth: '358px',
      },
    };
  },

  tileBox: () => {
    return  {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '80px',
      height: '80px',
      marginTop: '5px',
      border: '1px solid #BDBCBE80',
      borderRadius: '12px',

      '&:hover': {
        backgroundColor: '#F7F7F7',
        boxShadow: '0px 4px 4px 0px #00000040',
      },

      '&.schedule-selected': {
        backgroundColor: '#DEDDDF',
        borderColor: '#BDBCBE',
      },
    };
  },

  tile: () => {
    return  {
      width: '56px',
      height: '56px',
    };
  },

  categorySpace: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',

    '&.MuiGrid-root': {
      height: '50px',
      marginBottom: '0px',
    },
  },

  categoryUI: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0px',
    // width: '200px',
    '&.MuiGrid-root': {
      height: '40px',
      marginBottom: '0px',
    },
  },

  categorySelect: {
    minWidth: '185px',
   

    '&.MuiGrid-root': {
      height: '40px',
      marginBottom: '0px',

      '& .MuiFormControl-root': {

      },
    },
  },

  categoryLabel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '8px',
    height: '40px',
    fontSize: '12px',
    fontWeight: 'bold',

    '&.MuiGrid-root': {
        margin: '0px',
        marginRight: '8px',
    },

    '& span': {
      marginTop: '-5px',
    },
  },

});

export default styles;
export const useStyles = makeStyles(styles);
